import React, { useCallback, useEffect, useRef } from 'react';

import { useHotkeys } from 'react-hotkeys-hook';

import { WIDGET_REMOVAL_ACTION } from '../../lib/widgetRemoval';

import { useModalContext } from './ModalPortal';
import { SmallDialog, SmallDialogActions, SmallDialogButton } from './SmallDialog';

const COPY = {
  [WIDGET_REMOVAL_ACTION.DELETE]: {
    title: 'Delete widget?',
    body: 'This permanently deletes the widget for everyone in the chat. This cannot be undone.',
    confirm: 'Delete',
  },
  [WIDGET_REMOVAL_ACTION.UNPUBLISH]: {
    title: 'Unpublish widget?',
    body: 'This removes the widget from the board but keeps it available to publish again later.',
    confirm: 'Unpublish',
  },
};

function RemoveWidgetConfirmation({ action = WIDGET_REMOVAL_ACTION.DELETE, onClose, onConfirm }) {
  const { unlocked } = useModalContext();
  const cancelButtonRef = useRef(null);
  const confirmButtonRef = useRef(null);

  const handleEnterRouting = useCallback(() => {
    if (!unlocked()) return;
    if (confirmButtonRef.current === document.activeElement) onConfirm();
    else if (cancelButtonRef.current === document.activeElement) onClose();
  }, [unlocked, onConfirm, onClose]);

  const hotkeyRef = useHotkeys('enter', handleEnterRouting, { enableOnFormTags: true, preventDefault: true }, [handleEnterRouting]);

  useEffect(() => confirmButtonRef.current?.focus(), []);

  const copy = COPY[action] || COPY[WIDGET_REMOVAL_ACTION.DELETE];

  return (
    <SmallDialog title={copy.title} ref={hotkeyRef}>
      <p className="text-[13px] leading-[18px] text-gray-500 dark:text-neutral-400">{copy.body}</p>

      <SmallDialogActions>
        <SmallDialogButton ref={cancelButtonRef} onClick={onClose} variant="secondary">
          Cancel
        </SmallDialogButton>
        <SmallDialogButton
          ref={confirmButtonRef}
          onClick={onConfirm}
          variant={action === WIDGET_REMOVAL_ACTION.UNPUBLISH ? 'primary' : 'danger'}
        >
          {copy.confirm}
        </SmallDialogButton>
      </SmallDialogActions>
    </SmallDialog>
  );
}

export default RemoveWidgetConfirmation;
